import {
  blueGrey,
  grey,
  indigo,
  lightBlue,
  lightGreen,
  orange,
  pink,
  purple,
  red,
  teal,
  yellow,
} from "@mui/material/colors";

export const MethodCategories = {
  DIY: "DIY / 3D Printed",
  DT: "Dual Tension",
  Inflation: "Inflation",
  Manual: "Manual",
  Other: "Other",
  Packing: "Packing",
  Retaining: "Retaining",
  Taping: "Taping",
  Traction: "Traction",
  Traditional: "Traditional",
  Weights: "Weights",
};

export const MethodColors = {};
MethodColors[MethodCategories.DIY] = indigo;
MethodColors[MethodCategories.DT] = red;
MethodColors[MethodCategories.Inflation] = lightGreen;
MethodColors[MethodCategories.Manual] = lightBlue;
MethodColors[MethodCategories.Other] = blueGrey;
MethodColors[MethodCategories.Packing] = pink;
MethodColors[MethodCategories.Retaining] = yellow;
MethodColors[MethodCategories.Taping] = orange;
MethodColors[MethodCategories.Traction] = grey;
MethodColors[MethodCategories.Traditional] = purple;
MethodColors[MethodCategories.Weights] = teal;

// AllMethods has been moved to the app/methods Firestore document
// This allows for dynamic method management without code changes
